import { useEffect } from 'react';

const useSetCursorPosition = (inputRef, inputValue) => {
    useEffect(() => {
        if (inputRef.current) {
            const cursorPosition = inputRef.current.value.length - 1;
            inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
        }
    }, [inputValue]);
};

export default useSetCursorPosition;